
import Modal from 'react-modal';

const ModalSave = ({ active = false }) => {

    const css = {
        display: "flex", justifyContent: "center"
    }

    const styleCss = {
        overlay: { display: "flex", justifyContent: 'center', background: 'rgba(255, 255, 255, 1)' }
    }

    return (
        <Modal className="modal-re-ni" isOpen={active} style={styleCss} ariaHideApp={false}>
            <div className="mt-50" style={css}>
                <div className='loader-auto-cr'>   </div>
            </div>
            <div className="mt-20" style={{ ...css, color: "#008866", fontWeight: 600 }}>
                <label style={{ fontSize: '30px' }}>En Proceso</label>
            </div>
            <div style={{ ...css, color: "#4D4D4D", textAlign: 'center' }} className="mt-10">
                <label>Estamos generando la oferta de <br></br> seguro de automóvil</label>
            </div>
        </Modal>
    )
}

export { ModalSave }